import { useState, useEffect } from 'react';

const UseTranslationData = (aiForm, lang) => {
  if (aiForm.translations && aiForm.translations[lang]) {
    return aiForm.translations[lang];
  } else {
   // console.warn(`No translation data found for language: ${lang}`);
   return aiForm.translations['en'];
  }
};


const getRandomMessage = inputString => {
    // const messages = inputString.split('|');
    // const trimmedMessages = messages.map(message => message.trim());
    // const randomIndex = Math.floor(Math.random() * trimmedMessages.length);
    // return trimmedMessages[randomIndex];

    if (!inputString || typeof inputString !== 'string') return '';
    // If there's no '|' just return the trimmed string
    if (inputString.indexOf('|') === -1) return inputString.trim();

    const messages = inputString
      .split('|')
      .map(message => message.trim())
      .filter(Boolean);

    if (messages.length === 0) return '';
    if (messages.length === 1) return messages[0];

    const randomIndex = Math.floor(Math.random() * messages.length);
    return messages[randomIndex];
  };

export { getRandomMessage,UseTranslationData };
